export default __webpack_public_path__ + "static/media/potion2.e923db93.png";